"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobxState = void 0;
const mobx_1 = require("mobx");
class MobxState {
    constructor() {
        this.reactions = [];
    }
    autorun(view) {
        this.reactions.push((0, mobx_1.autorun)(view));
    }
    reaction(expression, effect, opts) {
        this.reactions.push((0, mobx_1.reaction)(expression, effect, opts));
    }
    /**
     * Destroy any observers that this class has made.
     */
    destroy() {
        this.reactions.forEach((r) => r());
    }
}
exports.MobxState = MobxState;
//# sourceMappingURL=mobx.js.map